import { postData } from './fetch';
import debounce from './debounce';
import changeZharcoins from './changeZharcoins';
import getCookie from "./get-cookie";

const ZHARCOINS_INPUT_TYPE = {
  count: 'count',
  range: 'range',
};

window.addEventListener('load', () => {
  const emailString = document.querySelector('.email-wrapper-left span');
  const rangeInput = document.querySelectorAll('.zharcoins-range input');
  const zharcoinsInputs = document.querySelectorAll('.zharcoins-count input');
  const resetZharcoinsButton = document.querySelectorAll(
    '.reset-zharcoins-button',
  );
  const changeChexbox = document.querySelector('.change-checkbox');
  const changeInputWrapper = document.querySelector(
    '.change-wrapper .input-wrapper',
  );
  const changeInput = document.querySelector(
    '.change-wrapper .input-wrapper .change-input',
  );
  const streetIdInput = document.querySelectorAll('.street-id');
  const houseInput = document.querySelectorAll('.house');
  const floorInput = document.querySelectorAll('.floor');
  const flatInput = document.querySelectorAll('.flat');
  const addressEntranceInput = document.querySelectorAll('.entrance');
  const addressCommentInput = document.querySelectorAll('.comment');
  const deliveryTimeInput = document.querySelectorAll('.delivery-time');
  const restaurantIdInput = document.querySelectorAll('.restaurant-id');
  const pickupTimeInput = document.querySelectorAll('.pickup-time');
  const popupEmailInput = document.querySelector('.popup-email-input');
  const acceptEmailButton = document.querySelector('.accept-email');
  const emailError = document.querySelector('.email-popup .email-error');
  const emailPopupWrapper = document.querySelector('.email-popup-wrapper');
  const deliveryPaymentsForm = document.querySelectorAll('.delivery-payment-form');
  const pickupPaymentsForm = document.querySelectorAll('.pickup-payment-form');
  const timePopup = document.querySelector('.time-popup-wrapper');
  const closePopupButton = document.querySelector('.time-popup-wrapper a');
  const orderTime = document.querySelector('.order-time');
  const onlinePaymentErrors = document.querySelector('.online-payment-errors');
  const cardPaymentErrors = document.querySelector('.card-payment-errors');
  const cashPaymentErrors = document.querySelector('.cash-payment-errors');
  const arrowBack = document.querySelector('.arrow-back');
  const cartId = getCookie('cartId');

  let formValues = {};

  const formValuesFromSessionStorage = sessionStorage ? sessionStorage.getItem('formValues') : null;

  if (formValuesFromSessionStorage) {
    formValues = JSON.parse(formValuesFromSessionStorage);
  }

  if (formValues && Object.keys(formValues).length) {
    if (formValues.streetId && streetIdInput) {
      [].forEach.call(
        streetIdInput,
        (input) => (input.value = formValues.streetId),
      );
    }

    if (formValues.house && houseInput) {
      [].forEach.call(houseInput, (input) => (input.value = formValues.house));
    }

    if (formValues.floor && floorInput) {
      [].forEach.call(floorInput, (input) => (input.value = formValues.floor));
    }

    if (formValues.flat && flatInput) {
      [].forEach.call(flatInput, (input) => (input.value = formValues.flat));
    }

    if (formValues.entrance && addressEntranceInput) {
      [].forEach.call(
        addressEntranceInput,
        (input) => (input.value = formValues.entrance),
      );
    }

    if (formValues.comment && addressCommentInput) {
      [].forEach.call(
        addressCommentInput,
        (input) => (input.value = formValues.comment),
      );
    }

    if (formValues.deliveryTime && deliveryTimeInput) {
      [].forEach.call(
        deliveryTimeInput,
        (input) => (input.value = formValues.deliveryTime),
      );
    }

    if (formValues.organizationId && restaurantIdInput) {
      [].forEach.call(
        restaurantIdInput,
        (input) => (input.value = formValues.organizationId),
      );
    }

    if (formValues.pickupTime && pickupTimeInput) {
      [].forEach.call(
        pickupTimeInput,
        (input) => (input.value = formValues.pickupTime),
      );
    }
  }

  const getElementsForZharcoinsInputs = ({
    input,
    type,
  }) => {
    const parentElement = input.closest('form');
    const zharcoinsSection = input.closest('.zharcoins-section');
    const inputElement = type === ZHARCOINS_INPUT_TYPE.range
      ? zharcoinsSection.querySelector('.zharcoins-range input')
      : zharcoinsSection.querySelector('.zharcoins-count input');
    const zharcoinsInputs = parentElement.querySelectorAll('.zharcoins-count-input');

    return {
      inputElement,
      zharcoinsInputs,
      bonusesString: parentElement.querySelector(`#bonus-${inputElement.dataset.walletid}`),
      total: parentElement.querySelector('.total span'),
      submitSum: parentElement.querySelector('.submit span'),
      submitButton: document.querySelector('.order-submit'),
      errorText: document.querySelectorAll('.payment-form .error-text'),
    };
  };

  const formattingInputValue = (value) => {
    return value || 0;
  };

  const drawRangeInput = ({
    input,
    value,
  }) => {
    const min = parseFloat(input.getAttribute('min')).toFixed(0);
    const max = parseFloat(input.getAttribute('max')).toFixed(0);

    const val = (value - min) / (max - min);

    const percent = val * 100;

    input.style.backgroundImage = `-webkit-gradient(linear, left top, right top, color-stop(${percent}%, #f02f2e), color-stop(${percent}%, #ffcac3))`;
    input.style.backgroundImage = `-moz-linear-gradient(left center, #f02f2e 0%, #f02f2e ${percent}%, #ffcac3 ${percent}%, #ffcac3 100%)`;
  };

  const changeSum = ({
    total,
    value,
    submitSum,
    bonusesString,
    allZharcoinsValue,
  }) => {
    const formattedValue = formattingInputValue(value);
    const formattedAllZharcoins = formattingInputValue(allZharcoinsValue);

    if (bonusesString) {
      bonusesString.textContent = parseFloat(formattedValue).toFixed(0);
    }

    if (!total) return;

    const totalValue = (
        (total.dataset.fulltotal - total.dataset.discount) - formattedAllZharcoins
    ).toFixed(2);

    total.textContent = totalValue;
    total.dataset.sum = totalValue;

    if (submitSum) {
      submitSum.textContent = totalValue;
      submitSum.dataset.price = totalValue;
    }
  };

  const getAllBonuses = (elements) => {
    if (!elements) return 0;

    let resultSumBonuses = 0;

    [].forEach.call(elements, (element) => {
      resultSumBonuses = resultSumBonuses + Number(element.value);
    });

    return resultSumBonuses;
  };

  const formattingWalletInfo = (elements) => {
    if (!elements) return [];

    return [].map.call(elements, (element) => ({
      id: element.dataset.walletid,
      amount: parseInt(element.value, 10) * 100,
    }));
  };

  if (rangeInput) {
    [].forEach.call(rangeInput, (input) => {
      const {
        inputElement: countInput,
        bonusesString,
        total,
        submitSum,
        submitButton,
        errorText,
        zharcoinsInputs,
      } = getElementsForZharcoinsInputs({
        input,
        type: ZHARCOINS_INPUT_TYPE.count,
      });

      input.addEventListener('input', () => {
        drawRangeInput({
          input,
          value: parseInt(formattingInputValue(input.value), 10),
        });

        if (countInput) {
          countInput.value = parseFloat(formattingInputValue(input.value)).toFixed(0);
        }

        const bonuses = getAllBonuses(zharcoinsInputs);

        changeSum({
          total,
          submitSum,
          bonusesString,
          value: input.value,
          allZharcoinsValue: bonuses,
        });
      });

      input.addEventListener('change', () => {
        const walletInfo = formattingWalletInfo(zharcoinsInputs);

        changeZharcoins({
          errorText,
          submitButton,
          value: walletInfo,
        });
      });
    });
  }

  if (zharcoinsInputs) {
    [].forEach.call(zharcoinsInputs, (input) => {
      const {
        inputElement: rangeInput,
        bonusesString,
        total,
        submitSum,
        submitButton,
        errorText,
      } = getElementsForZharcoinsInputs({
        input,
        type: ZHARCOINS_INPUT_TYPE.range,
      });

      input.addEventListener('keydown', (e) => {
        if (['+','-','e', ',', '.'].includes( e.key )) {
          e.preventDefault();
        }
      });

      input.addEventListener(
        'input',
        debounce(() => changeZharcoins({
          errorText,
          submitButton,
          value: formattingWalletInfo(zharcoinsInputs),
        }), 500),
      );

      input.addEventListener('keyup', () => {
        const max = parseInt(input.getAttribute('max'), 10);

        if (formattingInputValue(input.value) > max) {
          input.value = max;
        }

        if (rangeInput) {
          rangeInput.value = parseFloat(formattingInputValue(input.value)).toFixed(0);
          drawRangeInput({
            input: rangeInput,
            value: parseFloat(formattingInputValue(input.value)).toFixed(0),
          })
        }

        const bonuses = getAllBonuses(zharcoinsInputs);

        changeSum({
          total,
          submitSum,
          bonusesString,
          value: input.value,
          allZharcoinsValue: bonuses,
        });
      });
    });
  }

  if (resetZharcoinsButton) {
    [].forEach.call(resetZharcoinsButton, (button) => {
      const parentElement = button.closest('form');
      const zharcoinsSection = button.closest('.zharcoins-section');
      const rangeInput = zharcoinsSection.querySelector('.zharcoins-range input');
      const countInput = zharcoinsSection.querySelector('.zharcoins-count input');
      const bonusesString = parentElement.querySelector(`#bonus-${button.dataset.walletid}`);
      const total = parentElement.querySelector('.total span');
      const submitSum = parentElement.querySelector('.submit span');
      const submitButton = document.querySelector('.order-submit');
      const errorText = document.querySelectorAll('.payment-form .error-text');

      button.addEventListener('click', () => {
        if (rangeInput) {
          rangeInput.value = 0;

          rangeInput.style.backgroundImage =
            '-webkit-gradient(linear, left top, right top, color-stop(0%, #f02f2e), color-stop(0%, #ffcac3))';
          rangeInput.style.backgroundImage =
            '-moz-linear-gradient(left center, #f02f2e 0%, #f02f2e 0%, #ffcac3 0%, #ffcac3 100%)';
        }

        if (countInput) {
          countInput.value = 0;
        }

        if (bonusesString) {
          bonusesString.textContent = 0;
        }

        if (total) {
          total.textContent = total.dataset.sum;
        }

        if (submitSum) {
          submitSum.textContent = total.dataset.sum;
        }

        const bonuses = getAllBonuses(zharcoinsInputs);

        changeSum({
          total,
          submitSum,
          bonusesString,
          value: 0,
          allZharcoinsValue: bonuses,
        });

        changeZharcoins({
          errorText,
          submitButton,
          value: formattingWalletInfo(zharcoinsInputs),
        });
      });
    });
  }

  if (changeInput) {
    changeInput.addEventListener('input', (e) => {
      changeInput.value = e.target.value.replace(/[^0-9]/g, '');
    });
  }

  if (changeChexbox) {
    changeChexbox.addEventListener('click', () => {
      if (changeChexbox.checked) {
        changeInputWrapper.classList.add('visible');
      } else {
        changeInputWrapper.classList.remove('visible');
      }
    });
  }

  if (deliveryPaymentsForm) {
    [].forEach.call(deliveryPaymentsForm, (form) => {
      const submitBtn = form.querySelector('.order-submit');

      const streetId = form.querySelector('.street-id');
      const house = form.querySelector('.house');
      const floor = form.querySelector('.floor');
      const flat = form.querySelector('.flat');
      const entrance = form.querySelector('.entrance');
      const comment = form.querySelector('.comment');
      const type = form.querySelector('.type');
      const activeTab = form.querySelector('.active-tab');
      const paymentType = form.querySelector('.payment-type');
      const deliveryTime = form.querySelector('.delivery-time');
      const change = form.querySelector('.change-input');
      const email = form.querySelector('.email-input');

      form.addEventListener('submit', async (e) => {
        submitBtn.classList.add('disabled');
        submitBtn.textContent = 'Загрузка...';
        ym(82678129,'reachGoal','oplata');

        e.preventDefault();

        const body = {
          paymentType: paymentType.value,
          type: type.value,
        };

        if (streetId && streetId.value) {
          body.streetId = streetId.value;
        }

        if (house && house.value) {
          body.house = house.value;
        }

        if (floor && floor.value) {
          body.floor = floor.value;
        }

        if (flat && flat.value) {
          body.flat = flat.value;
        }

        if (entrance && entrance.value) {
          body.entrance = entrance.value;
        }

        if (comment && comment.value) {
          body.comment = comment.value;
        }

        if ((deliveryTime && deliveryTime.value !== 'Как можно скорее') || formValues.deliveryTime !== 'Как можно скорее') {
          if (deliveryTime && deliveryTime.value && deliveryTime.value !== 'Как можно скорее') {
            body.deliveryTime = deliveryTime.value;
          } else if (formValues.deliveryTime) {
            body.deliveryTime = formValues.deliveryTime;
          }
        }

        if (change && change.value) {
          body.change = change.value;
        }

        if (email && email.value) {
          body.email = email.value;
        }

        if (activeTab && activeTab.value) {
          body.activeTab = activeTab.value;
        }

        const response = await postData('/order/create', body);

        if (!response.errors) {
          if (response.data.originalDeliveryTime !== response.data.deliveryTime) {
            if (timePopup) {
              timePopup.classList.add('active');
            }

            if (orderTime) {
              orderTime.textContent = response.data.deliveryTime;
            }

            if (closePopupButton) {
              closePopupButton.setAttribute('href', `/profile/orders/${response.data.id}`);
            }
          } else {
            window.location.href = `/profile/orders/${response.data.id}`;
          }
        } else if (response.errors) {
          submitBtn.classList.remove('disabled');
          submitBtn.innerHTML = `Оформить за <span data-price="${submitBtn.dataset.price}">${submitBtn.dataset.price}</span> ₽`;

          const items = response.errors.map((item) => `<li>${item}</li>`);

          if (response.activeTab === 'online' && onlinePaymentErrors) {
            onlinePaymentErrors.innerHTML = items.join('');
          }

          if (response.activeTab === 'card' && cardPaymentErrors) {
            cardPaymentErrors.innerHTML = items.join('');
          }

          if (response.activeTab === 'cash' && cashPaymentErrors) {
            cashPaymentErrors.innerHTML = items.join('');
          }
        }
      });
    });
  }

  if (pickupPaymentsForm) {
    [].forEach.call(pickupPaymentsForm, (form) => {
      const submitBtn = form.querySelector('.order-submit');

      const organizationId = form.querySelector('.restaurant-id');
      const type = form.querySelector('.type');
      const activeTab = form.querySelector('.active-tab');
      const paymentType = form.querySelector('.payment-type');
      const pickupTime = form.querySelector('.pickup-time');
      const email = form.querySelector('.email-input');

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        arrowBack.classList.add('arrow-back-disabled')
        submitBtn.classList.add('disabled');
        submitBtn.textContent = 'Загрузка...';
        ym(82678129,'reachGoal','oplata');

        const body = {
          paymentType: paymentType.value,
          type: type.value,
        };

        if (organizationId && organizationId.value) {
          body.organizationId = organizationId.value;
        }

        if (activeTab && activeTab.value) {
          body.activeTab = activeTab.value;
        }

        if ((pickupTime && pickupTime.value !== 'Как можно скорее') || formValues.pickupTime !== 'Как можно скорее') {
          if (pickupTime && pickupTime.value && pickupTime.value !== 'Как можно скорее') {
            body.pickupTime = pickupTime.value;
          } else if (formValues.pickupTime) {
            body.pickupTime = formValues.pickupTime;
          }
        }

        if (email && email.value) {
          body.email = email.value;
        }

        const response = await postData('/order/create', body);

        if (!response.errors) {
          if (response.data.originalDeliveryTime !== response.data.deliveryTime) {
            if (timePopup) {
              timePopup.classList.add('active');
            }

            if (orderTime) {
              orderTime.textContent = response.data.deliveryTime;
            }

            if (closePopupButton) {
              closePopupButton.setAttribute('href', `/profile/orders/${response.data.id}`);
            }
          } else {
            window.location.href = `/profile/orders/${response.data.id}`;
          }
        } else if (response.errors) {
          arrowBack.classList.remove('arrow-back-disabled')
          submitBtn.classList.remove('disabled');
          submitBtn.innerHTML = `Оформить за <span data-price="${submitBtn.dataset.price}">${submitBtn.dataset.price}</span> ₽`;

          const items = response.errors.map((item) => `<li>${item}</li>`);

          if (response.activeTab === 'online' && onlinePaymentErrors) {
            onlinePaymentErrors.innerHTML = items.join('');
          }

          if (response.activeTab === 'card' && cardPaymentErrors) {
            cardPaymentErrors.innerHTML = items.join('');
          }

          if (response.activeTab === 'cash' && cashPaymentErrors) {
            cashPaymentErrors.innerHTML = items.join('');
          }
        }
      });
    });
  }

  if (acceptEmailButton) {
    acceptEmailButton.addEventListener('click', async () => {
      let email;
      const { name } = acceptEmailButton.dataset;

      if (popupEmailInput.value) {
        email = popupEmailInput.value;
      }

      acceptEmailButton.classList.add('disabled');
      acceptEmailButton.textContent = 'Загрузка';

      const body = {
        email,
        name,
      };

      const response = await postData('/profile/information', body);

      if (response) {
        if (response.statusCode !== 400) {
          acceptEmailButton.classList.remove('disabled');
          acceptEmailButton.textContent = 'Подтвердить';
          emailPopupWrapper.classList.remove('active');

          if (emailString) {
            emailString.textContent = email;
          }
        } else {
          acceptEmailButton.classList.remove('disabled');
          acceptEmailButton.textContent = 'Подтвердить';

          if (emailError) {
            emailError.classList.add('visible');

            if (response.errors.email && response.errors.email[0]) {
              emailError.textContent = response.errors.email[0];
            }

            if (response.errors._global && response.errors._global[0]) {
              emailError.textContent = response.errors._global[0];
            }
          }
        }
      }
    });
  }
});
